import { TypeBuildingAction } from "./reducerBuildings";
export var TypeActionBuildings;
(function (TypeActionBuildings) {
    TypeActionBuildings["None"] = "None";
    TypeActionBuildings["StartPurchase"] = "Buildings > StartPurchase";
    TypeActionBuildings["PurchaseConfirmationRequest"] = "Buildings > PurchaseConfirmationRequest";
    TypeActionBuildings["PurchaseConfirmed"] = "Buildings > PurchaseConfirmed";
    TypeActionBuildings["StartPlacement"] = "Buildings > StartPlacement";
    TypeActionBuildings["CancelPlacement"] = "Buildings > CancelPlacement";
    TypeActionBuildings["FinishPlacement"] = "Buildings > FinishPlacement";
    TypeActionBuildings["StartMove"] = "Buildings > StartMove";
    TypeActionBuildings["CancelMove"] = "Buildings > CancelMove";
    TypeActionBuildings["FinishMove"] = "Buildings > FinishMove";
    TypeActionBuildings["Move"] = "Buildings > Move";
    TypeActionBuildings["Rotate"] = "Buildings > Rotate";
    TypeActionBuildings["Temporary"] = "Buildings > Temporary";
    TypeActionBuildings["StartUpgrade"] = "Buildings > StartUpgrade";
    TypeActionBuildings["RequestUpgrade"] = "Buildings > RequestUpgrade";
    TypeActionBuildings["UpgradeConfirmationRequest"] = "Buildings > UpgradeConfirmationRequest";
    TypeActionBuildings["UpgradeConfirmed"] = "Buildings > UpgradeConfirmed";
    TypeActionBuildings["Demolish"] = "Buildings > Demolish";
    TypeActionBuildings["StoreBuilding"] = "Buildings > StoreBuilding";
    TypeActionBuildings["StartUnstoreBuilding"] = "Buildings > StartUnstoreBuilding";
    TypeActionBuildings["UnstoreBuilding"] = "Buildings > UnstoreBuilding";
    TypeActionBuildings["CancelUnstore"] = "Buildings > CancelUnstore";
    TypeActionBuildings["FinishUnstoreBuilding"] = "Buildings > FinishUnstoreBuilding";
    TypeActionBuildings["Select"] = "Buildings > Select";
    TypeActionBuildings["PreSelect"] = "Buildings > PreSelect";
    TypeActionBuildings["Deselect"] = "Buildings > Deselect";
    TypeActionBuildings["SkipConstruction"] = "Buildings > SkipConstruction";
    TypeActionBuildings["SkipOngoingConstruction"] = "Buildings > SkipOngoingConstruction";
    TypeActionBuildings["SkipConstructionConfirmed"] = "Buildings > SkipConstructionConfirmed";
    TypeActionBuildings["SelectBeforePlacement"] = "Buildings > SelectBeforePlacement";
    TypeActionBuildings["RewriteCenter"] = "Buildings > RewriteCenter";
    TypeActionBuildings["BouncingArrow"] = "Buildings > BouncingArrow";
    TypeActionBuildings["AddPellets"] = "Buildings > AddPellets";
})(TypeActionBuildings || (TypeActionBuildings = {}));
export var actionBuildingsStartPurchase = function (building, premium) {
    if (premium === void 0) { premium = false; }
    return ({
        action: TypeBuildingAction.Construct,
        building: building,
        premium: premium,
        type: TypeActionBuildings.StartPurchase,
    });
};
export var actionBuildingsAddPellets = function (building) { return ({
    action: TypeBuildingAction.None,
    building: building,
    type: TypeActionBuildings.AddPellets,
}); };
export var actionBuildingPurchaseConfirmationRequest = function (building, premium) {
    if (premium === void 0) { premium = false; }
    return ({
        action: TypeBuildingAction.Construct,
        building: building,
        premium: premium,
        type: TypeActionBuildings.PurchaseConfirmationRequest,
    });
};
export var actionBuildingPurchaseConfirmed = function (building, premium) {
    if (premium === void 0) { premium = false; }
    return ({
        action: TypeBuildingAction.Construct,
        building: building,
        premium: premium,
        type: TypeActionBuildings.PurchaseConfirmed,
    });
};
export var actionBuildingsStartPlacement = function (building, premium) {
    if (premium === void 0) { premium = false; }
    return ({
        action: TypeBuildingAction.Construct,
        building: building,
        premium: premium,
        type: TypeActionBuildings.StartPlacement,
    });
};
export var actionBuildingsFinishPlacement = function (building, premium) { return ({
    action: TypeBuildingAction.Construct,
    building: building,
    premium: premium,
    type: TypeActionBuildings.FinishPlacement,
}); };
export var actionBuildingsTemporaryPlacement = function (building, isPlacementValid, premium) { return ({
    action: TypeBuildingAction.Construct,
    building: building,
    isPlacementValid: isPlacementValid,
    premium: premium,
    type: TypeActionBuildings.Temporary,
}); };
export var actionBuildingsMovePlacement = function (building, premium) { return ({
    action: TypeBuildingAction.Construct,
    building: building,
    premium: premium,
    type: TypeActionBuildings.Move,
}); };
export var actionBuildingsRotatePlacement = function (building, premium) { return ({
    action: TypeBuildingAction.Construct,
    building: building,
    premium: premium,
    type: TypeActionBuildings.Rotate,
}); };
export var actionBuildingsRequestUpgrade = function (building, premium) {
    if (premium === void 0) { premium = false; }
    return ({
        action: TypeBuildingAction.Upgrade,
        building: building,
        premium: premium,
        type: TypeActionBuildings.RequestUpgrade,
    });
};
export var actionBuildingsCancelPlacement = function () { return ({
    type: TypeActionBuildings.CancelPlacement,
}); };
export var actionBuildingsStartMove = function (building) { return ({
    action: TypeBuildingAction.Move,
    building: building,
    type: TypeActionBuildings.StartMove,
}); };
export var actionBuildingsTemporaryMove = function (building, isPlacementValid) { return ({
    action: TypeBuildingAction.Move,
    building: building,
    isPlacementValid: isPlacementValid,
    type: TypeActionBuildings.Temporary,
}); };
export var actionBuildingsMoveMove = function (building) { return ({
    action: TypeBuildingAction.Move,
    building: building,
    type: TypeActionBuildings.Move,
}); };
export var actionBuildingsRotateMove = function (building) { return ({
    action: TypeBuildingAction.Move,
    building: building,
    type: TypeActionBuildings.Rotate,
}); };
export var actionBuildingsStartUpgrade = function (building) { return ({
    action: TypeBuildingAction.Select,
    building: building,
    type: TypeActionBuildings.StartUpgrade,
}); };
export var actionBuildingsFinishMove = function (building) { return ({
    action: TypeBuildingAction.Move,
    building: building,
    type: TypeActionBuildings.FinishMove,
}); };
export var actionBuildingsCancelMove = function () { return ({
    type: TypeActionBuildings.CancelMove,
}); };
export var actionBuildingsSelect = function (building, pos, centerOnBuilding) { return ({
    action: TypeBuildingAction.Select,
    building: building,
    buildingCenterCoords: pos,
    centerOnBuilding: centerOnBuilding,
    type: TypeActionBuildings.Select,
}); };
export var actionBuildingsPreSelect = function (building, pos) { return ({
    action: TypeBuildingAction.None,
    building: building,
    buildingCenterCoords: pos,
    type: TypeActionBuildings.PreSelect,
}); };
export var actionBuildingsSelectForData = function (building, pos, centerOnBuilding) { return ({
    action: TypeBuildingAction.None,
    building: building,
    buildingCenterCoords: pos,
    centerOnBuilding: centerOnBuilding,
    type: TypeActionBuildings.Select,
}); };
export var actionBuildingsDeselect = function () { return ({
    type: TypeActionBuildings.Deselect,
}); };
export var actionBuildingsShowBouncingArrow = function (building, showBouncingArrow) { return ({
    action: TypeBuildingAction.Upgrade,
    building: building,
    showBouncingArrow: showBouncingArrow,
    type: TypeActionBuildings.BouncingArrow,
}); };
export var actionBuildingsDemolish = function (building) { return ({
    action: TypeBuildingAction.None,
    building: building,
    type: TypeActionBuildings.Demolish,
}); };
export var actionBuildingsStoreBuilding = function (building) { return ({
    action: TypeBuildingAction.Store,
    building: building,
    type: TypeActionBuildings.StoreBuilding,
}); };
export var actionBuildingsStartUnstoreBuilding = function (building) { return ({
    action: TypeBuildingAction.Unstore,
    building: building,
    type: TypeActionBuildings.StartUnstoreBuilding,
}); };
export var actionBuildingsUnstoreBuilding = function (building) { return ({
    action: TypeBuildingAction.Unstore,
    building: building,
    type: TypeActionBuildings.UnstoreBuilding,
}); };
export var actionBuildingsTemporaryUnstore = function (building, isPlacementValid) { return ({
    action: TypeBuildingAction.Unstore,
    building: building,
    isPlacementValid: isPlacementValid,
    type: TypeActionBuildings.Temporary,
}); };
export var actionBuildingsMoveUnstore = function (building) { return ({
    action: TypeBuildingAction.Unstore,
    building: building,
    type: TypeActionBuildings.Move,
}); };
export var actionBuildingsRotateUnstore = function (building) { return ({
    action: TypeBuildingAction.Unstore,
    building: building,
    type: TypeActionBuildings.Rotate,
}); };
export var actionBuildingsFinishUnstoreBuilding = function (building) { return ({
    action: TypeBuildingAction.Unstore,
    building: building,
    type: TypeActionBuildings.FinishUnstoreBuilding,
}); };
export var actionBuildingsCancelUnstoreBuilding = function () { return ({
    type: TypeActionBuildings.CancelUnstore,
}); };
export var actionBuildingUpgradeSkipOnGoingConstruction = function (building, action) { return ({
    action: action || TypeBuildingAction.None,
    building: building,
    type: TypeActionBuildings.SkipOngoingConstruction,
}); };
export var actionBuildingsSkipConstruction = function (building, action) { return ({
    action: action || TypeBuildingAction.None,
    building: building,
    type: TypeActionBuildings.SkipConstruction,
}); };
export var actionBuildingsSkipConstructionConfirmed = function (building, action) { return ({
    action: action || TypeBuildingAction.None,
    building: building,
    type: TypeActionBuildings.SkipConstructionConfirmed,
}); };
export var actionBuildingsSelectBeforePlacement = function (building, premium) {
    if (premium === void 0) { premium = false; }
    return ({
        action: TypeBuildingAction.None,
        building: building,
        premium: premium,
        type: TypeActionBuildings.SelectBeforePlacement,
    });
};
export var actionBuildingUpgradeConfirmationRequest = function (building, premium) {
    if (premium === void 0) { premium = false; }
    return ({
        action: TypeBuildingAction.None,
        building: building,
        premium: premium,
        type: TypeActionBuildings.UpgradeConfirmationRequest,
    });
};
export var actionBuildingUpgradeConfirmed = function (building, premium) {
    if (premium === void 0) { premium = false; }
    return ({
        action: TypeBuildingAction.None,
        building: building,
        premium: premium,
        type: TypeActionBuildings.UpgradeConfirmed,
    });
};
export var actionBuildingsRewriteCenter = function (center) { return ({
    buildingCenterCoords: center,
    type: TypeActionBuildings.RewriteCenter,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/actionBuildings.ts
// module id = 21
// module chunks = 3